/**
 * Vuelta al menú de Winegang (app.winegang.es), donde están todos los juegos.
 *
 * Solo va en el inicio y en el login. Dentro del juego, volver lleva al inicio
 * del juego, y desde ahí este botón lleva al menú: así nunca hay dos «volver»
 * a la vez. En la app (Capacitor) el juego se abre en la misma vista que el
 * menú, y este enlace es la forma de regresar.
 */
export const MENU_WINEGANG = 'https://app.winegang.es/';

export default function VolverWinegang() {
  return (
    <a href={MENU_WINEGANG} className="volver-winegang" aria-label="Volver al menú de Winegang">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
      <span>Winegang</span>
    </a>
  );
}
